export const ADMIN_REFRESH_COOKIE_KEY = "admin_refresh_token";
export const TRAINER_REFRESH_COOKIE_KEY = "trainer_refresh_token";
